import { alpha, getPath } from '@mui/system';
export const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};
const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};
const getTextDecoration = _ref => {
  let {
    theme,
    ownerState
  } = _ref;
  const transformedColor = transformDeprecatedColors(ownerState.color);
  const color = getPath(theme, "palette.".concat(transformedColor), false) || ownerState.color;
  const channelColor = getPath(theme, "palette.".concat(transformedColor, "Channel"));
  if ('vars' in theme && channelColor) {
    return "rgba(".concat(channelColor, " / 0.4)");
  }
  return alpha(color, 0.4);
};
export default getTextDecoration;